import { FolderAssetType } from './constants';

export const getAssetTypeOptions = i18n => [
  {
    key: FolderAssetType.Image,
    text: i18n.getString(_TL_('Image')),
    title: i18n.getString(_TL_('Image')),
  },
  {
    key: FolderAssetType.Video,
    text: i18n.getString(_TL_('Video')),
    title: i18n.getString(_TL_('Video')),
  },
];
